
module.exports = {
  'header.docs': '文档',
  'header.help': '帮助',
  'header.blog': '博客',
  'header.changelog': '更新日志',
  'header.search.placeholder': '搜索...',
  'button.edit': '编辑',
  'title.changelog': '更新日志',
  'title.help': '帮助'
}



// WEBPACK FOOTER //
// ../~/picidae-theme-haier/pages/locale/zh-CN.js